import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JobApplicationService {

  constructor(private http: HttpClient) { }

  getVacancyById(vacancyId: bigint){
    return this.http.get(`${environment.apiUrl}/v1/vacancies/client-get-vacancy/` + vacancyId);
  }

  applyVacancy(vacantId: any): Observable<any>{
    return this.http.get(`${environment.apiUrl}/v1/applicants/apply/` + vacantId );
  }
}
